// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fa03e7e5","553":"c8b6232b"}[chunkId] + ".chunk.js";
};